import {
  ELENCO_MAX,
  JUROS_MENSAIS_PCT,
  LIMITE_JUNIORES,
  NOME_LIGA,
  PARCELA_EMPRESTIMO,
  agruparTrofeus,
  classificacaoDoGrupo,
  clubePorId,
  lanceMinimo,
  textoRodada,
  type FaseCopa,
  type LinhaTabela,
  type NomeFase,
  type Leilao,
  dataDaRodada,
  folhaMensal,
  jurosMensais,
  limiteEmprestimo,
  multaRescisao,
  percentualMulta,
  precoJunior,
  type Clube,
  type EstadoJogo,
  type Jogador,
  type Trofeu,
} from '../core';
import { agoraDoServidor } from './relogio';
import { app, humano, jogoAtual } from './app';
import { campoDinheiro } from './dinheiro';
import { dialogo } from './dialogos';
import { escudo, icone, logoCampeonato } from './icones';
import { classeReal, marcaTecnico } from './tecnicos-reais';
import { NOME_POSICAO, classeIdade, dataBR, dinheiroCurto, dinheiroExtenso, esc, num } from './util';

// ---- Juniores (a.ds do original) ---------------------------------------------------------------

export function dlgJuniores(): string {
  const e = jogoAtual();
  const h = humano();
  const alvoId = app.juniores.clubeId ?? h.id;
  const c = clubePorId(e, alvoId);
  const proprio = c.id === h.id;
  const lista = c.juniores ?? [];
  const sel = lista.find((j) => j.id === app.juniores.jogadorId) ?? lista[0] ?? null;
  const opcoes = [...e.clubes]
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
    .map((x) => `<option value="${x.id}" ${x.id === alvoId ? 'selected' : ''}>${esc(x.nome)}${x.id === h.id ? ' (seu time)' : ''}</option>`)
    .join('');
  const linhas = [...lista]
    .sort((a, b) => (b.desenvolvimento ?? 0) - (a.desenvolvimento ?? 0))
    .map((j) => {
      const dv = Math.min(100, Math.floor(j.desenvolvimento ?? 0));
      return `<tr class="lin${sel && j.id === sel.id ? ' sel' : ''}" data-a="jr-sel" data-id="${j.id}" tabindex="0"><td>${j.posicao}</td><td class="esq">${esc(j.nome)}</td>
        <td class="${classeIdade(j.idade)}">${j.idade}</td><td>${j.lado}</td><td>${j.overall}</td>
        <td><div class="conf-barra pequena" role="img" aria-label="Desenvolvimento ${dv}%"><i style="width:${dv}%"></i><b>${dv}%</b></div></td>
        <td>${dinheiroCurto(j.valor)}</td><td>${dinheiroCurto(j.salario)}</td></tr>`;
    })
    .join('');
  const vagas = proprio ? `Vagas: ${lista.length}/${LIMITE_JUNIORES}` : `${lista.length} jogadores`;
  const cheioProfissional = h.elenco.length >= ELENCO_MAX;
  const acoesProprio = proprio
    ? `<button class="btn principal" data-a="jr-promover" ${sel && !cheioProfissional ? '' : 'disabled'} title="${cheioProfissional ? 'Não há vagas no time profissional' : ''}">Promover</button>
       <button class="btn" data-a="jr-dispensar" ${sel ? '' : 'disabled'}>Dispensar</button>
       <input class="apelido" type="text" maxlength="24" placeholder="Apelido" value="${esc(app.juniores.apelido)}" data-ch="jr-apelido" aria-label="Apelido do junior" />
       <button class="btn" data-a="jr-apelido" ${sel ? '' : 'disabled'}>Definir apelido</button>`
    : (() => {
        const preco = sel ? precoJunior(sel) : 0;
        const cheio = (h.juniores ?? []).length >= LIMITE_JUNIORES;
        return `<button class="btn principal" data-a="jr-comprar" ${sel && !cheio && h.caixa >= preco ? '' : 'disabled'} title="${cheio ? 'Limite de juniores alcançado' : ''}">Propor compra${sel ? ` (${dinheiroCurto(preco)})` : ''}</button>`;
      })();
  const info = sel
    ? `<p><b>${esc(sel.nome)}</b> - ${NOME_POSICAO[sel.posicao]} - ${sel.idade} anos - força ${sel.overall}</p>
       <p class="cinza peq">Cada semana o desenvolvimento sobe até os 20 anos. Ao subir para o profissional, ele vira força extra (maior com mais talento).</p>`
    : '<p class="cinza">Nenhum junior.</p>';
  return dialogo(
    'Academia de Juniores',
    `<div class="dlg-tit amarelo">Academia de Juniores - ${esc(c.nome)} <span class="dlg-sub">${vagas}</span></div>
    <div class="dlg-corpo">
      <label class="campo-linha">Ver clube: <select data-ch="jr-clube">${opcoes}</select></label>
      <div class="rolavel resultados alta"><table class="tab-dlg"><thead><tr><th>P</th><th class="esq">Nome</th><th>Idade</th><th>L</th><th>F</th><th>Desenvolvimento</th><th>Valor estimado</th><th>Salário</th></tr></thead>
      <tbody>${linhas || '<tr><td class="esq" colspan="8">Sem juniores.</td></tr>'}</tbody></table></div>
      ${info}
    </div>
    <div class="dlg-botoes"><span class="rotulo-sel">${icone('estadio', 16)} ${dinheiroExtenso(h.caixa)}</span>${acoesProprio}<button class="btn" data-a="fechar">Fechar</button></div>`,
    'grande',
  );
}

// ---- Finanças (a.cW do original) ----------------------------------------------------------------

function linhaFin(rotulo: string, valor: number, negrito = false): string {
  const t = valor < 0 ? `-${num(Math.abs(valor))}` : num(valor);
  return `<tr class="${negrito ? 'tot' : ''}"><td class="esq">${rotulo}</td><td class="${valor < 0 ? 'neg' : ''}">${t}</td></tr>`;
}

export function dlgFinancas(): string {
  const c = humano();
  const b = c.balanco;
  const receitas = b.bilheteria + (b.vendas ?? 0) + b.premios + b.patrocinio;
  const despesas = (b.compras ?? 0) + (b.estadio ?? 0) + b.salarios + (b.juros ?? 0) + (b.multas ?? 0);
  const divida = c.emprestimo ?? 0;
  const limite = limiteEmprestimo(1);
  return dialogo(
    'Finanças',
    `<div class="dlg-tit amarelo">Finanças - temporada ${jogoAtual().temporada}</div>
    <div class="dlg-corpo duas">
      <div><table class="tab-dlg fin"><tbody>
        <tr class="sec"><td class="esq" colspan="2">Receitas</td></tr>
        ${linhaFin('Ingressos:', b.bilheteria)}${linhaFin('Venda de Jogadores:', b.vendas ?? 0)}${linhaFin('Prêmios:', b.premios)}${linhaFin('Patrocínio/Sócio torcedor:', b.patrocinio)}${linhaFin('Multas/outros:', 0)}
        ${linhaFin('Total de receitas:', receitas, true)}
        <tr class="sec"><td class="esq" colspan="2">Despesas</td></tr>
        ${linhaFin('Compras de jogadores:', b.compras ?? 0)}${linhaFin('Estádio:', b.estadio ?? 0)}${linhaFin('Salários:', b.salarios)}${linhaFin('Juros de empréstimo:', b.juros ?? 0)}${linhaFin('Multa de rescisão:', b.multas ?? 0)}${linhaFin('Diversos:', 0)}
        ${linhaFin('Total de despesas:', despesas, true)}
        ${linhaFin('Saldo:', receitas - despesas, true)}
      </tbody></table></div>
      <div class="fin-lado">
        <p><b>Dinheiro em caixa:</b> ${dinheiroExtenso(c.caixa)}</p>
        <p><b>Folha mensal:</b> ${dinheiroExtenso(folhaMensal(c))}</p>
        <h3>EMPRÉSTIMO BANCÁRIO</h3>
        <p><b>Valor já emprestado:</b> ${dinheiroExtenso(divida)}</p>
        <p><b>Juros mensais:</b> ${dinheiroExtenso(jurosMensais(c))} <span class="cinza">(${JUROS_MENSAIS_PCT}% ao mês)</span></p>
        <p class="cinza peq">Limite: ${dinheiroExtenso(limite)}. Cada operação move ${dinheiroExtenso(PARCELA_EMPRESTIMO)}.</p>
        <div class="grade-btn"><button class="btn" data-a="emp-pegar" ${divida >= limite ? 'disabled' : ''}>Pegar 500 mil</button>
        <button class="btn" data-a="emp-pagar" ${divida <= 0 || c.caixa < PARCELA_EMPRESTIMO ? 'disabled' : ''}>Pagar 500 mil</button></div>
        <p class="cinza peq">Vender jogador com contrato paga multa de rescisão (12% a 35% do valor, conforme os dias de contrato restantes).</p>
      </div>
    </div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'medio',
  );
}

// ---- Galeria de troféus (a.de do original) ------------------------------------------------------

const NOME_TIPO: Record<Trofeu['tipo'], string> = { nacional: 'Liga nacional', copa: 'Copa nacional', estadual: 'Estadual', internacional: 'Internacional' };

export function galeriaTrofeus(lista: Trofeu[]): string {
  const grupos = agruparTrofeus(lista);
  if (grupos.length === 0) return '<p class="cinza">Nenhum troféu ainda. Seja campeão para encher a galeria.</p>';
  const celulas = grupos
    .map((g) => {
      const anos = g.temporadas.map((t) => dataDaRodada(t, 0).getUTCFullYear()).join(', ');
      const div = g.tipo === 'nacional' || g.tipo === 'estadual' ? ` - ${g.divisao}ª divisão` : '';
      // as taças com foto (Brasileirão Série A e Copa do Brasil) aparecem como na vida real; as demais seguem com o ícone
      const foto = g.tipo === 'nacional' && g.divisao === 1 && /Série A/i.test(g.competicao) ? 'serie-a' : g.tipo === 'copa' && /Copa do Brasil/i.test(g.competicao) ? 'copa-do-brasil' : null;
      const imagem = foto ? `<img class="trofeu-foto" src="./trofeus/${foto}.jpg" alt="${esc(g.competicao)}" draggable="false" />` : icone('taca', 56);
      return `<div class="trofeu" title="${esc(anos)}">${imagem}<b>${esc(g.competicao)}</b><span>${NOME_TIPO[g.tipo]}${div}</span><em>${g.quantidade}x</em><small>${esc(anos)}</small></div>`;
    })
    .join('');
  return `<div class="galeria">${celulas}</div>`;
}

export function dlgTecnicos(): string {
  const e = jogoAtual();
  const h = humano();
  const linhas = [...e.clubes]
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
    .map((c) => `<tr class="${c.id === h.id ? 'humano' : ''}"><td class="esq">${escudo(c)}${esc(c.nome)}</td><td class="esq">${esc(c.id === h.id ? (e.tecnico ?? 'Técnico') + ' (você)' : (c.tecnico ?? '-'))}</td><td>${c.confiancaDiretoria}%</td></tr>`)
    .join('');
  return dialogo(
    'Técnicos',
    `<div class="dlg-tit amarelo">Técnicos - ${esc(e.nomeLiga ?? NOME_LIGA)}</div>
    <div class="dlg-corpo duas">
      <div><h3>TÉCNICOS DOS CLUBES</h3><div class="rolavel resultados alta"><table class="tab-dlg"><thead><tr><th class="esq">Time</th><th class="esq">Técnico</th><th>Diretoria</th></tr></thead><tbody>${linhas}</tbody></table></div>
        <p class="cinza peq">${e.ligaMundo ? 'Os técnicos dos clubes desta liga ainda não estão cadastrados.' : 'Técnicos reais da Série A 2026 (fonte: Wikipédia, 28/10/2026). Troca de técnicos, ranking e Central de Empregos ainda não existem.'}</p></div>
      <div><h3>TROFÉUS DO TÉCNICO</h3>${galeriaTrofeus(e.trofeusTecnico ?? [])}</div>
    </div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'grande',
  );
}

export function abaTrofeusClube(e: EstadoJogo): string {
  const alvoId = app.historia.clubeId ?? e.humanoId;
  const c: Clube = clubePorId(e, alvoId);
  const opcoes = [...e.clubes]
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
    .map((x) => `<option value="${x.id}" ${x.id === alvoId ? 'selected' : ''}>${esc(x.nome)}</option>`)
    .join('');
  return `<label class="campo-linha">Galeria de Troféus - <select data-ch="hist-clube">${opcoes}</select></label>${galeriaTrofeus(c.trofeus ?? [])}`;
}

/** Texto do contrato do jogador (cartão do jogador e janela Times). */
export function textoContrato(e: EstadoJogo, j: Jogador): string {
  const dias = j.contratoDias ?? 0;
  const fim = new Date(dataDaRodada(e.temporada, Math.min(e.rodada, e.calendario.length)).getTime() + dias * 86_400_000);
  return `${dataBR(fim)} (${dias} dias) · multa ${percentualMulta(dias)}% = ${dinheiroCurto(multaRescisao(j))}`;
}

// ---- Copa do Brasil: chaveamento ----------------------------------------------------------------

function golsRodada(e: EstadoJogo, rodada: number, mandante: number): [number, number] | undefined {
  return e.resultados.find((r) => r.rodada === rodada && r.mandante === mandante)?.gols;
}

/** Cartão de um confronto no chaveamento: os dois clubes com o agregado, e embaixo ida, volta e pênaltis. */
function cartaoConfronto(e: EstadoJogo, f: FaseCopa, i: number): string {
  const c = f.confrontos[i] as FaseCopa['confrontos'][number];
  const A = clubePorId(e, c.a);
  const B = clubePorId(e, c.b);
  const ida = golsRodada(e, f.rodadas[0] as number, c.a);
  const volta = f.rodadas.length > 1 ? golsRodada(e, f.rodadas[1] as number, c.b) : undefined;
  const jogou = Boolean(ida || volta);
  // a volta é mandada por B: o placar dela entra invertido para somar e mostrar sempre "A x B"
  const aggA = (ida?.[0] ?? 0) + (volta?.[1] ?? 0);
  const aggB = (ida?.[1] ?? 0) + (volta?.[0] ?? 0);
  const placar = (g: [number, number] | undefined): string => (g ? `${g[0]}x${g[1]}` : '–');
  const detalhe = [
    f.rodadas.length > 1 ? `Ida ${placar(ida)}` : `Jogo único ${placar(ida)}`,
    f.rodadas.length > 1 ? `Volta ${placar(volta ? [volta[1], volta[0]] : undefined)}` : '',
    c.penaltis ? `pên. ${c.penaltis[0]}x${c.penaltis[1]}` : '',
  ]
    .filter(Boolean)
    .join(' · ');
  const time = (x: Clube, gols: number): string => {
    const venc = c.vencedor === x.id;
    return `<div class="bk-time${venc ? ' venc' : ''}${c.vencedor !== undefined && !venc ? ' perdeu' : ''}">${escudo(x)}<span class="bk-nome">${esc(x.nome)}${marcaTecnico(x)}</span><b class="bk-placar">${jogou ? gols : ''}</b></div>`;
  };
  const hum = (A.humano || B.humano ? ' humano' : '') + classeReal(A, B);
  return `<div class="bk-card${hum}">${time(A, aggA)}${time(B, aggB)}<div class="bk-det">${detalhe}</div></div>`;
}

function cartaoVazio(): string {
  return `<div class="bk-card vazio"><div class="bk-time vazio"><span class="bk-nome">a definir</span></div><div class="bk-time vazio"><span class="bk-nome">a definir</span></div></div>`;
}

export function dlgChaveamento(): string {
  const e = jogoAtual();
  if (!e.copa) return '';
  return dialogo('Tabelas', `${corpoChaveamento(e)}<div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`, 'grande');
}

/** Chaveamento da Copa do Brasil (sem moldura de diálogo): usado no diálogo próprio da copa e na aba nacional das Tabelas. */
export function corpoChaveamento(e: EstadoJogo): string {
  const copa = e.copa;
  if (!copa) return '';
  return chaveamento(e, { nome: copa.nome, fases: copa.fases, campeaoId: copa.campeaoId, fixa: copa.fixa === true, logo: 'copa', rodape: `Oitavas, quartas e semifinais em ida e volta (vale o agregado; empate vai para os pênaltis). A final é jogo único. O caminho é definido no sorteio das oitavas: os vencedores seguem pelas linhas do chaveamento.${copa.fixa === true ? '' : ' (Este save é antigo: as fases seguintes são sorteadas quando a anterior termina.)'}` });
}

/** Libertadores ou Sul-Americana: os grupos (com a classificação ao vivo) e o chaveamento do mata-mata. */
export function corpoLibertadores(e: EstadoJogo, passada?: { grupos: LinhaTabela[][]; fases: FaseCopa[]; campeaoId: number | null; ano: number }, tipo: 'lib' | 'sul' = 'lib'): string {
  const lib = tipo === 'sul' ? e.sulamericana : e.libertadores;
  const sul = tipo === 'sul';
  const logo = sul ? 'sulamericana' : 'libertadores';
  const nomeCopa = sul ? 'Copa Sul-Americana' : 'Copa Libertadores';
  if (!lib && !passada) return `<div class="dlg-corpo"><p class="cinza peq">Este jogo não tem a ${nomeCopa}. Comece um novo jogo marcando "Disputar também a Libertadores e a Sul-Americana".</p></div>`;
  const letra = (i: number): string => String.fromCharCode(65 + i);
  const tabelasDosGrupos: LinhaTabela[][] = passada ? passada.grupos : (lib as NonNullable<typeof lib>).grupos.map((g) => classificacaoDoGrupo(e, g, lib));
  const grupos = tabelasDosGrupos
    .map((tabelaGrupo, i) => {
      const linhas = tabelaGrupo
        .map((l, k) => {
          const c = clubePorId(e, l.clubeId);
          const classe = (k < 2 ? 'zona-t' : '') + (c.humano ? ' humano' : '');
          const pais = lib?.paises[c.id] ?? e.libertadores?.paises[c.id] ?? '';
          return `<tr class="${classe}"><td>${k + 1}</td><td class="esq">${escudo(c)}${esc(c.nome)} <span class="cinza peq">${esc(pais)}</span></td><td>${l.pj}</td><td>${l.v}</td><td>${l.e}</td><td>${l.d}</td><td>${l.sg}</td><td><b>${l.pts}</b></td></tr>`;
        })
        .join('');
      return `<div class="grupo-lib"><h3 class="bk-tit">Grupo ${letra(i)}</h3><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq">Clube</th><th>J</th><th>V</th><th>E</th><th>D</th><th>SG</th><th>Pts</th></tr></thead><tbody>${linhas}</tbody></table></div>`;
    })
    .join('');
  const rodape = sul
    ? 'Fase de grupos em turno e returno. Os líderes esperam nas quartas; os segundos enfrentam, em ida e volta, os terceiros colocados da Libertadores (playoffs) e os vencedores pegam os líderes. Quartas e semifinais em ida e volta, sem gol fora: empate no agregado vai aos pênaltis. A final é jogo único.'
    : 'Quartas e semifinais em ida e volta, sem gol fora de casa: empate no agregado vai direto aos pênaltis. A final é jogo único em campo neutro (sem prorrogação no jogo: empate vai aos pênaltis). Os 2 melhores de cada grupo avançam e os terceiros vão aos playoffs da Sul-Americana.';
  const mata = chaveamento(e, {
    nome: lib?.nome ?? nomeCopa,
    fases: passada ? passada.fases : (lib as NonNullable<typeof lib>).fasesMata,
    campeaoId: passada ? passada.campeaoId : (lib as NonNullable<typeof lib>).campeaoId,
    fixa: false,
    logo,
    ano: passada?.ano,
    // saves antigos da Libertadores tinham 8 grupos e começavam nas oitavas
    ...(tabelasDosGrupos.length >= 8 ? {} : { inicio: 'quartas' as const }),
    playoffs: sul,
    rodape,
  });
  return `<div class="dlg-corpo rolavel alta"><div class="dlg-tit amarelo">${logoCampeonato(logo, 26)}Fase de grupos</div><div class="grupos-lib">${grupos}</div></div>${mata}`;
}

interface CompeticaoChave {
  nome: string;
  fases: FaseCopa[];
  campeaoId: number | null;
  fixa: boolean;
  logo: 'copa' | 'libertadores' | 'sulamericana';
  /** 'quartas': o mata-mata começa nas quartas (copas continentais com 4 grupos); padrão: oitavas */
  inicio?: 'quartas';
  /** mostra a fase de playoffs antes do chaveamento (Sul-Americana) */
  playoffs?: boolean;
  rodape: string;
  /** ano mostrado no título (padrão: o da temporada atual); as Tabelas de temporadas passadas informam o delas */
  ano?: number;
}

/** Chaveamento de oitavas a final (Copa do Brasil e Libertadores), sem moldura de diálogo. */
export function chaveamento(e: EstadoJogo, copa: CompeticaoChave): string {
  const campeao = copa.campeaoId === null ? null : clubePorId(e, copa.campeaoId);
  // Chaveamento espelhado: metade esquerda (confrontos 1 a 4 das oitavas) e direita (5 a 8) se encontram na final, no centro.
  // O caminho é fixo desde o sorteio das oitavas: o vencedor do confronto 2k+1 enfrenta o do 2k+2 na fase seguinte, então
  // dá para ligar os cartões com linhas. As fases ainda não jogadas aparecem como "a definir".
  const fixa = copa.fixa === true;
  const cartoes = (nome: NomeFase, qtd: number): string[] => {
    const f = copa.fases.find((x) => x.nome === nome);
    return Array.from({ length: qtd }, (_, i) => (f && f.confrontos[i] ? cartaoConfronto(e, f, i) : cartaoVazio()));
  };
  const estado = (nome: NomeFase): string => {
    const f = copa.fases.find((x) => x.nome === nome);
    return !f ? 'a definir' : f.concluida ? 'encerrada' : 'em andamento';
  };
  const oitavas = cartoes('Oitavas de final', 8);
  const quartas = cartoes('Quartas de final', 4);
  const semis = cartoes('Semifinais', 2);
  const final = cartoes('Final', 1)[0] as string;
  const par = (a: string, b: string): string => `<div class="bk-par${fixa ? ' lig' : ''}">${a}${b}</div>`;
  const solo = (a: string): string => `<div class="bk-solo${fixa ? ' lig' : ''}">${a}</div>`;
  const coluna = (nome: NomeFase, titulo: string, html: string): string =>
    `<div class="bk-col"><h3 class="bk-tit">${titulo}<small>${estado(nome)}</small></h3><div class="bk-lista">${html}</div></div>`;
  const soQuartas = copa.inicio === 'quartas';
  const lado = (classe: 'esq' | 'dir', ini: number): string => {
    const o = soQuartas ? '' : coluna('Oitavas de final', 'Oitavas', par(oitavas[ini] as string, oitavas[ini + 1] as string) + par(oitavas[ini + 2] as string, oitavas[ini + 3] as string));
    const qi = soQuartas ? ini / 4 * 2 : ini / 2;
    const q = coluna('Quartas de final', 'Quartas', par(quartas[qi] as string, quartas[qi + 1] as string));
    const s = coluna('Semifinais', 'Semifinal', solo(semis[ini / 4] as string));
    return `<div class="bk-lado ${classe}">${classe === 'esq' ? o + q + s : s + q + o}</div>`;
  };
  const nPlay = copa.fases.find((x) => x.nome === 'Playoffs')?.confrontos.length || 4;
  const playoffs = copa.playoffs
    ? `<div class="bk-playoffs"><h3 class="bk-tit">Playoffs (segundos da Sul-Americana x terceiros da Libertadores)<small>${estado('Playoffs')}</small></h3><div class="bk-lista bk-lista-linha">${cartoes('Playoffs', nPlay).join('')}</div></div>`
    : '';
  const centro = `<div class="bk-col bk-centro"><h3 class="bk-tit">Final<small>${estado('Final')}</small></h3>
    <div class="bk-lista"><div class="bk-card bk-campeao${campeao ? '' : ' vazio'}">${icone('taca', 30)}<div class="bk-time ${campeao ? 'venc' : 'vazio'}">${campeao ? `${escudo(campeao)}<span class="bk-nome">${esc(campeao.nome)}</span>` : '<span class="bk-nome">campeão a definir</span>'}</div></div>
      <div class="bk-solo ${fixa ? 'lig' : ''} bk-final">${final}</div></div></div>`;
  const fases = `<div class="bk">${lado('esq', 0)}${centro}${lado('dir', 4)}</div>`;
  const faixa = campeao ? `<div class="aviso-bf dentro">${icone('taca', 20)} Campeão: <b>${escudo(campeao)}${esc(campeao.nome)}</b></div>` : '';
  const ultima = Math.min(e.rodada, Math.max(0, e.calendario.length - 1));
  const situacao = e.formato === 'copa' ? ` - ${esc(textoRodada(e, ultima))}` : '';
  return `<div class="dlg-tit amarelo">${logoCampeonato(copa.logo, 26)}${esc(copa.nome)} ${copa.ano ?? dataDaRodada(e.temporada, 0).getUTCFullYear()}${situacao}</div>
    <div class="dlg-corpo rolavel alta">${faixa}${playoffs}${fases}
    <p class="cinza peq">${copa.rodape}</p></div>`;
}

// ---- Leilão entre técnicos humanos --------------------------------------------------------------

function restante(fim: number): number {
  const o = app.online;
  const v = o?.visao;
  if (!o || !v) return 0;
  return fim - agoraDoServidor();
}

export function formatarRestante(ms: number): string {
  if (ms <= 0) return 'encerrando...';
  const s = Math.ceil(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = s % 60;
  return h > 0 ? `${h}h ${String(m).padStart(2, '0')}min` : `${m}:${String(ss).padStart(2, '0')}`;
}

const TEXTO_SITUACAO: Record<Leilao['situacao'], string> = { aberto: 'aberto', vendido: 'vendido', 'sem-lances': 'sem lances', cancelado: 'cancelado', falhou: 'falhou' };

/** Anfitrião: técnicos que pediram para entrar no campeonato em andamento assumindo um clube da CPU. */
export function dlgPedidos(): string {
  const v = app.online?.visao;
  if (!v) return '';
  const e = jogoAtual();
  const linhas = v.sala.pedidos
    .map((p) => {
      const c = clubePorId(e, p.clubeId);
      const situacao = p.aprovado ? '<span class="cinza">aprovado: entra quando a rodada terminar</span>' : '';
      const botoes = p.aprovado
        ? ''
        : `<button class="btn peq principal" data-a="online-pedido-resp" data-id="${p.id}" data-ok="1">Aprovar</button> <button class="btn peq" data-a="online-pedido-resp" data-id="${p.id}" data-ok="0">Recusar</button>`;
      return `<tr><td class="esq"><b>${esc(p.nome)}</b>${p.conta ? ' <span class="cinza peq">(com conta)</span>' : ' <span class="cinza peq">(sem conta)</span>'}</td><td class="esq">${escudo(c)}${esc(c.nome)}</td><td>${situacao}${botoes}</td></tr>`;
    })
    .join('');
  return dialogo(
    'Pedidos de entrada',
    `<div class="dlg-tit amarelo">Pedidos de entrada</div>
    <div class="dlg-corpo">${linhas ? `<table class="tab-dlg"><thead><tr><th class="esq">Técnico</th><th class="esq">Clube pedido</th><th></th></tr></thead><tbody>${linhas}</tbody></table>` : '<p class="cinza">Nenhum pedido esperando.</p>'}
      <p class="cinza peq">Quem você aprovar assume o clube do jeito que ele está (elenco, caixa e posição na tabela) e passa a confirmar as rodadas junto com os outros técnicos.</p></div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'medio',
  );
}

export function dlgLeilao(): string {
  const o = app.online;
  const v = o?.visao;
  if (!o || !v) return '';
  const e = jogoAtual();
  const h = humano();
  const abertos = v.sala.leiloes.filter((l) => l.situacao === 'aberto');
  const encerrados = v.sala.leiloes.filter((l) => l.situacao !== 'aberto').slice(-8).reverse();
  const nomeClube = (id: number | null): string => (id === null ? '–' : esc(clubePorId(e, id).nome));
  const linhas = abertos
    .map((l) => {
      const minimo = lanceMinimo(l);
      const meu = l.vendedorId === h.id;
      const lider = l.lanceClubeId === h.id;
      const digitado = Number(app.leilao.valores[l.id] ?? 0);
      const valor = digitado >= minimo ? digitado : minimo;
      const acao = meu
        ? `<button class="btn peq" data-a="leilao-cancelar" data-id="${l.id}" ${l.lanceClubeId !== null ? 'disabled' : ''}>Cancelar</button>`
        : lider
          ? '<span class="cinza">Você lidera</span>'
          : `${campoDinheiro('leilao-valor', valor, {
              id: l.id,
              min: minimo,
              rotulo: 'Seu lance em reais',
              botoes: [{ rotulo: 'Mínimo', delta: 'min' }, { rotulo: '+100 mil', delta: 100_000 }, { rotulo: '+500 mil', delta: 500_000 }, { rotulo: '+1 mi', delta: 1_000_000 }],
            })}
             <button class="btn principal peq" data-a="leilao-lance" data-id="${l.id}" ${h.caixa < minimo ? 'disabled' : ''}>Dar lance</button>`;
      return `<tr class="${meu ? 'humano' : ''}"><td class="esq"><span class="pos pos-${esc(l.posicao)}">${esc(l.posicao)}</span> <b>${esc(l.jogador)}</b><br><span class="cinza">F:${l.overall} · ${l.idade} anos</span></td>
        <td class="esq">${nomeClube(l.vendedorId)}</td>
        <td>${l.lanceClubeId === null ? `<span class="cinza">a partir de</span><br>${dinheiroCurto(l.lance)}` : `<b>${dinheiroCurto(l.lance)}</b>`}</td>
        <td class="esq">${nomeClube(l.lanceClubeId)}</td>
        <td data-fim="${l.terminaEm}">${formatarRestante(restante(l.terminaEm))}</td><td class="esq">${acao}</td></tr>`;
    })
    .join('');
  const hist = encerrados
    .map((l) => `<tr><td class="esq">${esc(l.jogador)}</td><td class="esq">${nomeClube(l.vendedorId)}</td><td>${l.situacao === 'vendido' ? dinheiroCurto(l.lance) : '–'}</td>
      <td class="esq">${l.situacao === 'vendido' ? nomeClube(l.lanceClubeId) : '–'}</td><td class="esq">${TEXTO_SITUACAO[l.situacao]}${l.motivo ? ` <span class="cinza">(${esc(l.motivo)})</span>` : ''}</td></tr>`)
    .join('');
  const recebidas = v.sala.ofertasHumanas.filter((x) => x.vendedorId === h.id);
  const enviadas = v.sala.ofertasHumanas.filter((x) => x.compradorId === h.id);
  const linhaOferta = (x: (typeof recebidas)[number], recebida: boolean): string => {
    const acoes = recebida
      ? `<button class="btn principal peq" data-a="oferta-aceitar" data-id="${x.id}">Aceitar</button> <button class="btn peq" data-a="oferta-recusar" data-id="${x.id}">Recusar</button>`
      : `<button class="btn peq" data-a="oferta-cancelar" data-id="${x.id}">Cancelar</button>`;
    return `<tr><td class="esq"><span class="pos pos-${esc(x.posicao)}">${esc(x.posicao)}</span> <b>${esc(x.jogador)}</b><br><span class="cinza">F:${x.overall} · ${x.idade} anos</span></td>
      <td class="esq">${nomeClube(recebida ? x.compradorId : x.vendedorId)}</td><td><b>${dinheiroCurto(x.valor)}</b></td><td class="esq">${acoes}</td></tr>`;
  };
  const tabelaOfertas = (lista: typeof recebidas, recebida: boolean): string =>
    `<table class="tab-dlg"><thead><tr><th class="esq">Jogador</th><th class="esq">${recebida ? 'Comprador' : 'Dono'}</th><th>Oferta</th><th class="esq"></th></tr></thead><tbody>${lista.map((x) => linhaOferta(x, recebida)).join('')}</tbody></table>`;
  const blocoOfertas =
    (recebidas.length ? `<h3 class="fase-tit">Ofertas recebidas pelos seus jogadores</h3>${tabelaOfertas(recebidas, true)}<p class="cinza peq">Ao aceitar, o jogador sai na hora (com a multa de rescisão, se houver contrato) e o valor entra no seu caixa.</p>` : '') +
    (enviadas.length ? `<h3 class="fase-tit">Suas ofertas enviadas</h3>${tabelaOfertas(enviadas, false)}` : '');
  return dialogo(
    'Leilão',
    `<div class="dlg-tit amarelo">Leilão e ofertas entre técnicos</div>
    <div class="dlg-corpo rolavel alta">
      ${app.mensagem ? `<div class="aviso-bf dentro" role="status">${esc(app.mensagem)}</div>` : ''}
      ${blocoOfertas}
      ${linhas ? `<table class="tab-dlg leiloes"><thead><tr><th class="esq">Jogador</th><th class="esq">Vendedor</th><th>Lance</th><th class="esq">Líder</th><th>Termina em</th><th class="esq"></th></tr></thead><tbody>${linhas}</tbody></table>` : '<p class="cinza">Nenhum leilão aberto. Para leiloar um jogador seu, clique em Vender no cartão do jogador.</p>'}
      ${hist ? `<h3 class="fase-tit">Encerrados</h3><table class="tab-dlg"><thead><tr><th class="esq">Jogador</th><th class="esq">Vendedor</th><th>Valor</th><th class="esq">Comprador</th><th class="esq">Situação</th></tr></thead><tbody>${hist}</tbody></table>` : ''}
      <p class="cinza peq">O maior lance leva o jogador quando o tempo acaba. Lance nos últimos 60 segundos prorroga o leilão em 1 minuto. Quem vende com contrato paga a multa de rescisão. O seu caixa precisa cobrir o lance até o fim.</p>
    </div>
    <div class="dlg-botoes"><span class="rotulo-sel">${icone('estadio', 16)} ${dinheiroExtenso(h.caixa)}</span><button class="btn" data-a="fechar">Fechar</button></div>`,
    'grande',
  );
}

/** Bloco para abrir um leilão do jogador (aparece na janela de vendas do modo online). */
export function secaoLeiloar(jogadorId: number, valorSugerido: number): string {
  const sugerido = Math.max(50_000, Math.round(valorSugerido / 1000) * 1000);
  const preco = Number(app.leilao.preco) || sugerido;
  const dur = app.leilao.duracao;
  const opcoes: [string, string][] = [['5', '5 minutos'], ['30', '30 minutos'], ['60', '1 hora'], ['720', '12 horas'], ['1440', '24 horas']];
  return `<div class="leiloar"><h3 class="fase-tit">Leiloar entre os técnicos humanos</h3>
    <div class="leiloar-linha"><span class="leiloar-rot">Preço inicial</span>
      ${campoDinheiro('leilao-preco', preco, {
        min: 50_000,
        ref: sugerido,
        rotulo: 'Preço inicial em reais',
        botoes: [{ rotulo: 'Valor do passe', delta: 'ref' }, { rotulo: '−500 mil', delta: -500_000 }, { rotulo: '−100 mil', delta: -100_000 }, { rotulo: '+100 mil', delta: 100_000 }, { rotulo: '+500 mil', delta: 500_000 }],
      })}</div>
    <div class="leiloar-linha"><span class="leiloar-rot">Duração</span>
      <select data-ch="leilao-duracao" aria-label="Duração do leilão">${opcoes.map(([v, t]) => `<option value="${v}" ${dur === v ? 'selected' : ''}>${t}</option>`).join('')}</select></div>
    <p class="cinza peq">Mínimo R$ 50.000. O leilão termina no prazo escolhido, com prorrogação de 1 minuto se houver lance no final.</p>
    <button class="btn principal" data-a="leilao-criar" data-id="${jogadorId}">Abrir leilão</button></div>`;
}